import { inject } from '@angular/core';
import { SessionService } from '@wonder-core-ng/session-store/session.service';
import { provideFeatureFlags } from '@wonder-bi-front/feature-flags';
import { environment } from '../environment/environment';
import { TenantSelectionService } from '../session/tenant-selection.service';

/**
 * The signed-in user's feature flags, for the whole app. The core registers them in provideBiCore,
 * which this tenant does not call: it builds BI_CORE_CONFIG itself (biCoreConfigFactory) so the core
 * follows the tenant a SUPER_ADMIN picks at login, and the flags follow that same tenant. The session
 * tells the library when nobody is logged in and when the token is renewed (it then reloads them).
 */
export const FEATURE_FLAGS_PROVIDERS = provideFeatureFlags(() => ({
  apiBaseUrl: environment.api,
  tenant: inject(TenantSelectionService).current,
  session: inject(SessionService).session,
}));
